<template>
	<div class="height-100dvh">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="goBack()"
				src="../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Become Instructor
		</header>
		<main class="become-panel-container app-bottom-padding">
			<div class="d-flex flex-column align-items-center w-100">
				<div id="hideinmobile" class="cand-header d-flex mb-2">
					<img
						class="mr-3 d-flex pointer"
						src="../assets/img/homepage/back-arrow-blue.svg"
						alt=""
						@click="goBack()"
					/>
					Become an Instructor
				</div>
				<div class="becpan-inside-cont">
					<section class="becpan-top-back">
						<img
							id="hideinlaptop"
							class="becpan-img-3"
							src="../assets/newdesign/home/Become/WavesBackMob.png"
							alt=""
						/>
						<img
							id="hideinmobile"
							class="becpan-img-3"
							src="../assets/newdesign/home/Become/WavesBack.png"
							alt=""
						/>
						<img
							class="becpan-img-1"
							src="../assets/newdesign/home/Become/BecomeIns-1.svg"
							alt=""
						/>
						<img
							class="becpan-img-2"
							src="../assets/newdesign/home/Become/BecomeIns-2.svg"
							alt=""
						/>
						<img
							id="hideinlaptop"
							class="becpan-img-4"
							src="../assets/newdesign/home/Become/BecomeIns-mob1.svg"
							alt=""
						/>
						<b-skeleton
							class="w-50 mt-5"
							type="input"
							v-if="shimmerLoader"
						></b-skeleton>
						<span
							v-else
							class="becpan-fs-36 fw-M fam-mont text-blue z-ind-1 text-center"
							>{{
								licenseKey != null
									? "Start Creating Course"
									: "Become an Instructor"
							}}</span
						>
						<b-skeleton v-if="shimmerLoader" class="w-75"></b-skeleton>
						<b-skeleton v-if="shimmerLoader" class="w-50"></b-skeleton>

						<span
							v-else
							class="becpan-fs-20 becpan-w-43 fw-R fam-lato text-tertiary text-center z-ind-1"
							>Become an instructor and empower others by sharing your expertise
							and professional insights.</span
						>
						<b-skeleton type="button" v-if="shimmerLoader"></b-skeleton>
						<div v-else class="mob-addBtn position-relative becpan-w-13">
							<b-button @click="handleClick" class="w-100 fs-16">
								{{ buttonText }}
							</b-button>
							<div v-if="loader" class="loader-pos-mob">
								<Loader />
							</div>
						</div>
						<div v-if="showApprovalMessage" class="approval-message">
							<img
								src="../assets/newdesign/home/Become/white-tick.svg"
								alt=""
							/>
							We have received your application. We'll get back to you as soon
							as possible.
						</div>
					</section>
					<section class="ecpan-bottom-back">
						<div class="d-flex align-items-center gap-3">
							<div class="becpan-line"></div>
							<span class="fam-lato becpan-fs-20 fw-M text-grey"
								>Reasons to start</span
							>
							<div class="becpan-line"></div>
						</div>
						<div
							class="d-flex justify-content-around flex-wrap mt-3 becpan-gap-5"
						>
							<article class="becpan-card">
								<img
									src="../assets/newdesign/home/Become/BecomeIns-3.svg"
									alt=""
								/>
								<span class="text-center">Share Expertise</span>
								<h4 class="mb-0">
									Instructors can create and publish courses, sharing their
									knowledge with a global audience.
								</h4>
							</article>
							<article class="becpan-card">
								<img
									src="../assets/newdesign/home/Become/BecomeIns-4.svg"
									alt=""
								/>
								<span class="text-center">Expand your Reach</span>
								<h4 class="mb-0">
									Reach a diverse and growing community of learners across
									various industries.
								</h4>
							</article>
							<article class="becpan-card">
								<img
									src="../assets/newdesign/home/Become/BecomeIns-5.svg"
									alt=""
								/>
								<span class="text-center">Earn Revenue</span>
								<h4 class="mb-0">
									Generate income by offering high-quality courses that attract
									a wide range of learners.
								</h4>
							</article>
						</div>
					</section>
				</div>
			</div>
		</main>

		<b-modal
			id="gotoWeb"
			centered
			hide-footer
			hide-header
			@hidden="isInstMob = false"
			v-model="isInstMob"
		>
			<div class="d-flex flex-column align-items-center p-3">
				<img src="../assets/newdesign/home/Become/becIns-MobileDp.svg" alt="" />
				<span
					v-if="licenseKey != null"
					class="text-center fam-mont fs-16 fw-M mt-3"
				>
					Access your instructor profile <br />
					using the web interface
				</span>
				<span v-else class="text-center fam-mont fs-16 fw-M mt-3"
					>Create your instructor profile by <br />
					accessing the web interface.
				</span>
			</div>
		</b-modal>
		<b-modal
			id="becomeInstructor"
			centered
			hide-footer
			hide-header
			v-model="showBecomeInstrucModal"
			@hidden="closeModal()"
		>
			<div
				class="candash-modal-top d-flex align-items-center gap-2 justify-content-center p-3"
			>
				<img src="../assets/newdesign/home/Become/hire3x.svg" alt="" />
				<div class="jdp-modal-vertical-line"></div>
				<span class="text-blue fs-20 fw-LM fam-inter"
					>Become an instructor</span
				>
				<div
					class="d-flex justify-content-end pointer position-absolute bf-cross-pos"
				>
					<img
						class="rotate-on-hover"
						src="@/assets/newdesign/dashboard/blueCross.svg"
						alt=""
						@click="closeModal()"
					/>
				</div>
			</div>
			<div class="bec-ins-modal-height">
				<BecomeInstructorForm
					:currentStep="currentStep"
					@closeModal="closeModal()"
					@update:currentStep="currentStep = $event"
					@update:continueDisabled="continueDisabled = $event"
					@form-submitted="handleFormSubmitted"
				/>
			</div>
		</b-modal>

		<!--  create a alreadyExists modal  -->
		<b-modal
			id="alreadyExists"
			centered
			hide-footer
			hide-header
			@hidden="closeModal()"
		>
			<div class="d-flex flex-column py-2 align-items-center text-center">
				<img
					src="../assets/newdesign/home/Become/warning-shadow.svg"
					alt="Warning icon"
				/>

				<div class="inst-modal-head mt-3 fs-18">
					You're Already Part of an Organization
				</div>

				<p class="mt-2 px-1 mb-2 fs-13">
					We noticed you're already a member of the
					<span class="text-inst">{{
						instructorRoleData.organizationName
					}}</span>
					as a
					<span class="text-inst">{{ instructorRoleData.existingRole }}</span
					>. To continue, please follow one of the below instructions:
				</p>

				<div class="d-flex flex-column align-items-center mt-2">
					<p class="mb-0 fs-13">
						<span class="text-inst">1. Apply independently:</span> Use your
						personal account to submit a new application.
					</p>
					<p class="mb-0 inst-new fs-13">
						<span class="text-inst">2. Join via your organization :</span>
						Ask your organization's admin to add you as an instructor from their
						end.
					</p>
				</div>

				<b-button
					@click="$bvModal.hide('alreadyExists')"
					class="candash-addBtn mt-3"
					variant="primary"
				>
					Okay
				</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import mobHeader from "@/components/fixedcomponents/mobileHeader.vue";
import BecomeInstructorForm from "@/components/BecomeInstructorForm.vue";
import {
	createInstructor,
	getTrainingLic,
	getUserDetails,
	userAccess,
	userInfo,
	postInstructorInformation,
	instructorRoleExists,
} from "@/utils/apiFunctions";
import { config } from "@/config/index.js";
export default {
	name: "BecomeInstructor",
	components: {
		mobHeader,
		BecomeInstructorForm,
	},
	data() {
		return {
			currentStep: 1,
			continueDisabled: false,
			licenseKey: null,
			loader: false,
			shimmerLoader: true,
			isInstMob: false,
			isLaptop: true,
			submitted: false,
			approval: false,
			showBecomeInstrucModal: false,
			InstructorData: [],
			rejoinInstructorDate: "2025-09-08T07:40:24.747000",
			instructorRoleData: {},
		};
	},
	created() {
		this.getLicenseDetails();
		this.checkScreenSize();
		this.getUSerInfo();
		this.instructorStatus();
	},
	mounted() {
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}), // 👈 getter from your store

		showApprovalMessage() {
			return this.instructorStatusValue === 2;
		},
		instructorStatusValue() {
			return this.InstructorData?.[0]?.instructorInfo?.status ?? null;
		},

		isRejoinDatePassed() {
			const activity = this.InstructorData?.[0]?.instructorInfo?.activity;
			const rej = activity?.find((a) => a.status === 0);

			if (!rej?.rejoinInstructorDate) return false;

			const targetDate = new Date(rej.rejoinInstructorDate);
			targetDate.setHours(
				targetDate.getHours() + 5,
				targetDate.getMinutes() + 30
			);

			return new Date() >= targetDate;
		},

		buttonText() {
			const status = this.instructorStatusValue;

			if (
				status === null &&
				!this.isRejoinDatePassed &&
				this.licenseKey == null
			) {
				return "Get Started";
			}
			if (status === 2) {
				return "Go Back";
			}
			if (status === 0 && this.isRejoinDatePassed) {
				return "Apply";
			}
			if (status === 1 || this.licenseKey != null) {
				return "Continue";
			}
			return "Apply"; // fallback
		},
	},
	methods: {
		async instructorRoleExists() {
			const response = await instructorRoleExists(this.userInfo.email);
			if (response.status === 200) {
				this.instructorRoleData = response.data;
			}
		},
		showSuccess() {
			this.submitted = true;
			this.getUSerInfo();
		},
		closeModal() {
			this.showBecomeInstrucModal = false;
			this.currentStep = 1;
			this.getUSerInfo()
		},
		handleFormSubmitted(submitted) {
			this.submitted = submitted; // now parent knows child’s state
			this.continueNext();
		},
		continueNext() {
			if (this.submitted) {
				this.showBecomeInstrucModal = false;
				this.getUSerInfo();
				this.goBack();
				return;
			}
			if (this.currentStep <= 3) {
				this.currentStep += 1;
			}
		},
		async getUSerInfo() {
			const res = await userInfo();
			if (res.status == 200) {
				this.approval = res.data.data.offers.instrcutor_application;
			}
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		async getLicenseDetails() {
			try {
				const res = await getTrainingLic();
				if (res.status == 200) {
					this.licenseKey = res.data.data.licenseKey;
					setTimeout(() => {
						this.shimmerLoader = false;
					}, 200);
				}
			} catch (error) {
				throw new Error(error);
			} finally {
				this.shimmerLoader = false;
			}
		},
		async createAnInstructor() {
			try {
				this.loader = true;
				const res = await getUserDetails();
				if (res.status == 200) {
					let payload = {
						email: res.data.data.email,
						firstName: res.data.data.firstName,
						lastName: res.data.data.lastName,
						phoneNumber: res.data.data.phoneNumber,
					};

					const instRes = await createInstructor(payload);
					if (instRes.status == 200) {
						this.getLicenseDetails();
						const res = await userAccess();
						let trainingAccess = res.data.details.filter(
							(obj) => obj.project == "training"
						)[0];
						if (
							trainingAccess &&
							trainingAccess.userPermissions &&
							trainingAccess.userPermissions.isActive
						) {
							document.cookie = `training=${JSON.stringify(
								trainingAccess
							)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
							window.open(
								"https://trainingadmin.hire3x.com/?from=candidate",
								"_blank"
							);
						}
					}
				}
			} catch (error) {
				throw new Error(error);
			} finally {
				this.loader = false;
			}
		},
		goToTraining() {
			window.open(
				"https://trainingadmin.hire3x.com/?from=candidate",
				"_blank"
			);
		},
		becomeinstructor() {
			if (window.innerWidth > 1028) {
				this.licenseKey != null
					? this.goToTraining()
					: this.createAnInstructor();
			} else {
				this.$bvModal.show("gotoWeb");
			}
		},
		async handleClick() {
			const status = this.instructorStatusValue;
			if (
				(status === null &&
					!this.isRejoinDatePassed &&
					this.licenseKey == null) ||
				(status === 0 && this.isRejoinDatePassed)
			) {
				//check if role exists or not before applying
				await this.instructorRoleExists();
				if (!this.instructorRoleData.instructorCanApply) {
					this.$bvModal.show("alreadyExists");
					return;
				}
				// Condition 1
				if (this.isLaptop) {
					this.showBecomeInstrucModal = true;
				} else {
					this.$router.push({ name: "BecomeInstructorSurvey" });
				}
				return;
			}

			if (status === 2) {
				// Condition 2
				this.goBack();
				return;
			}

			if (status === 1 || this.licenseKey != null) {
				// Condition 4
				this.$router.push({ name: "InstructorResult" });
				return;
			}
		},
		async instructorStatus() {
			try {
				let payload = {
					email: this.userInfo.email,
				};

				const response = await postInstructorInformation(payload);
				if (response.status === 200) {
					this.InstructorData = response.data.data.data;
				}
			} catch (error) {
				console.error("API error:", error);
			}
		},
		goBack() {
			console.log("hiii", this.$route.query.from);
			const from = this.$route.query.from;

			if (from === "certificate") {
				window.location.replace(`${config.trainingBase}/certificate`);
			} else {
				this.$router.go(-1);
			}
		},
	},
};
</script>

<style>
/* .bec-ins-modal-height {
	height: calc(100vh - 392px);
	overflow: auto;
	max-height: 550px;
} */
.bf-cross-pos {
	right: 17px;
}
.approval-message {
	background: linear-gradient(90deg, #20639b 0%, rgba(32, 99, 155, 0.52) 100%);
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #ffffff;
	border-radius: 4px;
	padding: 5px 10px;
	position: relative;
	width: fit-content;
}
.text-inst {
	font-family: Montserrat;
	font-weight: 600;
	font-size: 13px;
	color: #344054;
}
.inst-modal-head {
	font-family: Lato;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}
</style>
